const formatDecimalTo2Places = (value) => {
    const parsedValue = parseFloat(value);
    if (!isNaN(parsedValue)) {
        return parsedValue.toFixed(2);
    }
    return "";
};

const formatAsDollar = (value) => {
    if (value === null || value === undefined || value === "") return "-";

    const parsedValue = parseFloat(value);

    if (isNaN(parsedValue)) return "-";

    const rounded = Math.round(parsedValue);
    return `${rounded.toLocaleString("en-US")}`;
};


export {
    formatDecimalTo2Places,
    formatAsDollar,
}
